import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { withRouter } from "react-router-dom";
import s from "./styles.scss";
import { Container } from "reactstrap";
import PagedTable from "../common/PagedTable";
import { QueryResponse } from "../../../types/QueryResponse";
import { CuentaContable } from "../../../types/CuentaContable";
import { deleteCuentaContableRequest } from "../../actions/cuentasContables";
import {
  errorNotification,
  successNotification
} from "../../../utils/notifications";
import { handleRequestError } from "../../../utils/helpers";
import ConfirmModal from "../common/confirmModal/confirmModal";

interface Props {
  cuentasContables: QueryResponse<CuentaContable>;
  defaultRows: string;
  fetchData: () => void;
  searching: boolean;
  onClickNewCuentaContable: (cuentaContable) => any;
}

class CuentasContables extends React.Component<Props> {
  state = {
    modalEliminar: false,
    cuentaEliminar: null
  };

  handleEditCuentaContable = cuentaContable => {
    this.props.onClickNewCuentaContable(cuentaContable);
  };

  handleDeleteCuentaContable = async cuentaContable => {
    this.setState({
      modalEliminar: true,
      cuentaEliminar: cuentaContable
    });
    /*const { cuentaContableId } = cuentaContable;
    if (!!cuentaContableId) {
      await deleteCuentaContableRequest(cuentaContableId)
        .then(() => {
          successNotification("Cuenta contable eliminada correctamente.");
          this.search();
        })
        .catch(handleRequestError);
    }*/
  };

  clearDeleteModal = () => {
    this.setState({
      cuentaEliminar: null,
      modalEliminar: false
    });
  };

  confirmDeleteCuentaContable = async () => {
    const { cuentaContableId } = this.state.cuentaEliminar;
    if (!!cuentaContableId) {
      try {
        await deleteCuentaContableRequest(cuentaContableId);
        successNotification("Cuenta contable eliminada correctamente.");
        this.clearDeleteModal();
        this.search();
      } catch (e) {
        errorNotification("No fue posible eliminar la cuenta contable");
      }
    }
  };

  search = () => {
    this.props.fetchData();
  };

  render() {
    const columns = [
      { name: "Nombre", id: "nombre" },
      { name: "Numero de cuenta", id: "numeroCuenta" },
      { name: "Activo", id: "activo", formatter: val => (val ? "SI" : "NO") },
      {
        headerActions: [
          {
            name: "add",
            f: this.props.onClickNewCuentaContable,
            label: "Crear nueva cuenta contable"
          }
        ]
      }
    ];

    const actions = [
      { name: "edit", f: this.handleEditCuentaContable },
      { name: "delete", f: this.handleDeleteCuentaContable }
    ];

    return (
      <Container className="mt-3 p-0">
        <PagedTable
          data={this.props.cuentasContables}
          columns={columns}
          actions={actions}
          fetchData={this.props.fetchData}
          searching={this.props.searching}
          defaultPageSize={100}
        />
        <ConfirmModal
          title="Eliminar cuenta contable"
          message="Confirme la eliminación de la cuenta contable"
          isOpen={this.state.modalEliminar}
          ok={() => {
            this.confirmDeleteCuentaContable();
          }}
          cancel={() => {
            this.setState({
              cuentaEliminar: null,
              modalEliminar: false
            });
          }}
        />
      </Container>
    );
  }
}
export default withRouter(withStyles(s)(CuentasContables));
